function fallbackCopyTextToClipboard(text: string) {
  const textArea = document.createElement('textarea');
  textArea.value = text;

  // Avoid scrolling to bottom
  textArea.style.top = '0';
  textArea.style.left = '0';
  textArea.style.position = 'fixed';

  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  let retVal;
  try {
    const successful = document.execCommand('copy');
    const msg = successful ? 'successful' : 'unsuccessful';
    console.log('Fallback: Copying text command was ' + msg);
    retVal = successful;
  } catch (err) {
    console.error('Fallback: Oops, unable to copy', err);
    retVal = err;
  }

  document.body.removeChild(textArea);
  return retVal;
}

export default function copyTextToClipboard(text: string) {
  if (!navigator.clipboard) {
    return new Promise<void>((resolve, reject) => {
      const res = fallbackCopyTextToClipboard(text);
      res ? resolve() : reject(res);
    });
  }
  return navigator.clipboard.writeText(text);
}
